import { FilterPanelSavedFilterType, SavedFilterObject } from "./types";

const getValueFromFilterObject = (value: string | SavedFilterObject) => {
  if (typeof value === "string") {
    return value;
  }

  if (value?.$like) {
    return value.$like;
  }

  if (value?.$in) {
    return value?.$in;
  }

  return;
};

const setKey = (
  accumulator: Record<string, string | string[]>,
  key: string,
  value?: string | string[]
) => {
  if (value) {
    accumulator[key] = value;
  }
};

export const filterResponseToFilterConfig = (
  filters: FilterPanelSavedFilterType
) =>
  Object.entries(filters).reduce(
    (accumulator: Record<string, string | string[]>, [key, value]) => {
      if (Array.isArray(value)) {
        const [[firstKey, firstValue]] = Object.entries(value[0]);
        setKey(
          accumulator,
          firstKey,
          getValueFromFilterObject(firstValue as string | SavedFilterObject)
        );
      } else {
        setKey(accumulator, key, getValueFromFilterObject(value));
      }

      return accumulator;
    },
    {}
  );
